<div class="modal-header b pb-0 pt-3 px-3">
  <h5 class="modal-title f-14 font-weight-500 text-defualt" id="createnote">Add Candidate </h5>
  <button data-testid="auto-app-create-candidate-new-button-1" type="button" class="close font-weight-normal ms-auto btn p-0 f-20" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body px-3">
  <form [formGroup]="create_candidate">
    <div class="row">
      <div class="col">
        <div class="ats-upload-btn d-flex justify-content-center align-items-center mb-4">

          <div class="col text-center p-3" *ngIf="!resumeFile">
            <div class="font-weight-500 text-bluex mb-0 ">
              <div class="col">
                <img src="../../../assets/images/resume-icon.png"  style="width: 36px;" alt="">
                <p class="font-weight-500 mt-3 mb-0"> Drag and Drop Resume file here</p>
              </div>
            </div>
            <div>

              <p *ngIf="specialCharaterError" [ngClass]="['my-1','text-danger']">
                Filename should not contain any special characters
              </p>
              <p *ngIf="incorrectFileFormat" [ngClass]="['my-1','text-danger']">
                File type should be .doc or .pdf or .docx or .txt
              </p>
              <p *ngIf="fileSizeLimitExceeded" [ngClass]="['my-1','text-danger']">
                File size cannot exceed 5 MB
              </p>
            </div>

          </div>
          <div class="f-14 d-flex py-5"  *ngIf="resumeFile">
            {{uploadFileName}}
            <i class="fas fa-times ml-2 pointer" (click)="removeFile()"></i>
          </div>

          <input data-testid="auto-app-create-candidate-new-input-1" type="file" #document (change)="uploadFile($event)" *ngIf="!resumeFile"
          accept=".doc,.docx,.txt,.pdf, .dot,.rtf,.odt,.htm,.html">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 mb-4"> <span class="custom-header">First Name </span> <span class="text-danger">*</span>
        <input data-testid="auto-app-create-candidate-new-input-2" type="text" placeholder="Enter First Name" formControlName="firstName" class="wc-form-control mt-3px">
        <p class="text-danger f-12 pt-1"
          *ngIf="create_candidate['controls'].firstName.hasError('required') && (create_candidate['controls'].firstName.dirty || create_candidate['controls'].firstName.touched)">
          First name is required</p>
        <p class="text-danger f-12 pt-1" *ngIf="create_candidate['controls'].firstName.hasError('pattern')">Only
          alphabets and numerics allowed</p>
      </div>
      <div class="col-md-6  mb-4">Last Name <span class="text-danger">*</span>
        <input data-testid="auto-app-create-candidate-new-input-3" type="text" placeholder="Enter Last Name" formControlName="lastName" class="wc-form-control mt-3px">
        <p class="text-danger f-12 pt-1"
          *ngIf="create_candidate['controls'].lastName.hasError('required') && (create_candidate['controls'].lastName.dirty || create_candidate['controls'].lastName.touched)">
          Last name is required</p>
        <p class="text-danger f-12 pt-1" *ngIf="create_candidate['controls'].lastName.hasError('pattern')">Only
          alphabets and numerics allowed</p>
      </div>
    </div>
    <div class="row">
      <div class="col mb-4">Company Name
      <input data-testid="auto-app-create-candidate-new-input-4" (input)="searchCompany()" type="text" placeholder="Enter Company Name"
                        #trigger="matAutocompleteTrigger" (keyup.enter)="trigger.closePanel()"
                        class="wc-form-control nobg mt-3px" formControlName="companyName"
                        [matAutocomplete]="company_auto">

        <mat-autocomplete #company_auto="matAutocomplete">
          <mat-option *ngFor="let company of companylist" [value]="company">
              {{company}}
          </mat-option>
        </mat-autocomplete>
      </div>

    </div>

    <div class="row">
      <div class="col-md-6  mb-4"> Job Name
        <input data-testid="auto-app-create-candidate-new-input-5" (input)="searchJobs()" type="text" placeholder="Enter Job Title" #trigger="matAutocompleteTrigger"
          (keyup.enter)="trigger.closePanel()" class="wc-form-control nobg mt-3px text-capitalize" formControlName="jobName"
          [matAutocomplete]="jobs_auto">

        <mat-autocomplete #jobs_auto="matAutocomplete">
          <mat-option *ngFor="let job of joblist" [value]="job">
            {{job}}
          </mat-option>
        </mat-autocomplete>

        <p *ngIf="create_candidate.get('jobName').errors?.required && (create_candidate['controls'].jobName.dirty || create_candidate['controls'].jobName.touched)"
          [ngClass]="['text-left','my-1','text-danger']">Job Name is required</p>
        <p *ngIf="create_candidate['controls'].jobName.hasError('pattern')" class="text-danger f-12 mb-0 pt-1">
          HTML tags are not allowed</p>
      </div>

      <div class="col-md-6  mb-4"> Location

        <input data-testid="auto-app-create-candidate-new-input-6" (input)="searchLocation()" type="text" placeholder="Enter Work Location" #trigger="matAutocompleteTrigger"
          (keyup.enter)="trigger.closePanel()" class="wc-form-control nobg mt-3px" formControlName="worklocation"
          [matAutocomplete]="location_auto">

        <mat-autocomplete #location_auto="matAutocomplete">
          <mat-option *ngFor="let location of locationlist" [value]="location">
            {{location}}
          </mat-option>
        </mat-autocomplete>


        <p *ngIf="create_candidate.get('worklocation').errors?.required && (create_candidate['controls'].worklocation.dirty || create_candidate['controls'].worklocation.touched)"
          [ngClass]="['text-left','my-1','text-danger']">Work Location is required</p>
        <p *ngIf="create_candidate['controls'].worklocation.hasError('pattern')" class="text-danger f-12 mb-0 pt-1">
          HTML tags are not allowed</p>
      </div>
    </div>


    <div class="row">
    <div class="col-md-6  mb-4"> Public Profile Link <span class="text-danger">*</span>
      <input data-testid="auto-app-create-candidate-new-input-7" type="text" placeholder="Enter Public Profile Link" class="wc-form-control nobg mt-3px"
          formControlName="publicProfileLink">
      <p class="f-12" *ngIf="create_candidate.get('publicProfileLink').errors?.required && (create_candidate['controls'].publicProfileLink.dirty || create_candidate['controls'].publicProfileLink.touched)"
          [ngClass]="['text-left','my-1','text-danger']">Public Profile Link is required</p>
      <p class="text-danger f-12 pt-1"
          *ngIf="create_candidate['controls'].publicProfileLink.hasError('pattern')">Must be a
          valid URL</p>
    </div>

    <div class="col-md-6  mb-4"> Source <span class="text-danger">*</span>
      <div class="position-relative">

          <div class="position-relative gray-text mt-3px">
              <input data-testid="auto-app-create-candidate-new-input-8" type="text" placeholder="Select Source" #trigger1="matAutocompleteTrigger" (input)="getSourceList()"
                  (keyup.enter)="trigger1.closePanel()" class="wc-form-control nobg" #talentpool formControlName="source"
                  [matAutocomplete]="source_list">

              <mat-autocomplete #source_list="matAutocomplete">
                  <mat-option *ngFor="let x of sourcelist_data" [value]="x"> {{x}} </mat-option>
              </mat-autocomplete>
          </div>
          </div>
      <p class="f-12" *ngIf="create_candidate.get('source').errors?.required && (create_candidate['controls'].source.dirty || create_candidate['controls'].source.touched)"
          [ngClass]="['text-left','my-1','text-danger']">Source is required</p>
    </div>
    </div>

<div class="row">
  <div class="col-md-6">
  <div class="f-14"> Select Talentpool
      <div class="position-relative">
          <div class="position-relative gray-text mt-3px">
              <input data-testid="auto-app-create-candidate-new-input-9" (input)="getAllTalentpool()" type="text" placeholder="Select Talentpool"
                  #trigger="matAutocompleteTrigger" (click)="getAllTalentpool()"
                  (mouseout)="getAllTalentpool()" (keyup.enter)="trigger.closePanel()"
                  class="wc-form-control nobg" #talentpool formControlName="talentpoolname"
                  [matAutocomplete]="talentpool_name">

              <mat-autocomplete #talentpool_name="matAutocomplete">
                  <mat-option *ngFor="let talentpool of talentpoolslist" [value]="talentpool.name"
                      (onSelectionChange)="openConfirmationModal(talentpool)">
                      {{talentpool.name}}
                  </mat-option>
              </mat-autocomplete>
          </div>
      </div>
      <p *ngIf="noTalentpoolError" class="f-12" [ngClass]="['text-left','my-1','text-danger']">No Such Talentpool</p>
  </div>
</div>
</div>
</form>

</div>​
<div class="modal-footer b">
  <button data-testid="auto-app-create-candidate-new-button-2" class="btn-trms-medium" (click)="createCandidate()"> Add Candidate</button>
</div>
